import { ProjectRepository } from "@project/data/repositories/project.repository";
import {
    ProjectListDashboard,
    createEmptyProjectListDashboard,
} from "@project/domain/models/project-list-dashboard.model";
import { ProjectSearchFilters } from "@project/domain/models/project-search-filters";
import { inject, injectable } from "inversify";

@injectable()
export class GetProjectListDashboardUseCase {
    constructor(
        @inject(ProjectRepository)
        private readonly projectRepository: ProjectRepository,
    ) {}

    async execute(
        filters?: ProjectSearchFilters,
    ): Promise<ProjectListDashboard> {
        const dashboardResult =
            await this.projectRepository.getProjectListDashboard(filters);

        return dashboardResult.fold(
            () => createEmptyProjectListDashboard(),
            (dashboard) => dashboard,
        );
    }
}
